export default {
  drawerTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-title',
    defaultMessage: 'Add shipping rules for {categoryGroup}',
  },
  categorySelection: {
    id: 'bo_seller-options-shipping-rule_drawer-category_selection',
    defaultMessage: 'Category selection',
  },
  allCategories: {
    id: 'bo_seller-options-shipping-rule_drawer-all_categories',
    defaultMessage: 'All categories',
  },
  deliveryDeadline: {
    id: 'bo_seller-options-shipping-rule_drawer-delivery_deadline',
    defaultMessage: 'Delivery deadline',
  },
  summary: {
    id: 'bo_seller-options-shipping-rule_drawer-summary',
    defaultMessage: 'Summary',
  },
  preparationTimeTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-preparation_time_title',
    defaultMessage:
      'Preparation time for products within this group is {time}.',
  },
  freeShippingTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-free_shipping_title',
    defaultMessage: 'Add your free shipping option',
  },
  freeShippingTitleOptional: {
    id: 'bo_seller-options-shipping-rule_drawer-optional_free_shipping_title',
    defaultMessage: 'Add your free shipping option (optional)',
  },
  freeShippingDescription: {
    id: 'bo_seller-options-shipping-rule_drawer-free_shipping_description',
    defaultMessage:
      'You must offer at least 1 free shipping method per market.',
  },
  paidShippingTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-paid_shipping_title',
    defaultMessage: 'Add your paid shipping option',
  },
  paidShippingTitleOptional: {
    id: 'bo_seller-options-shipping-rule_drawer-optional_paid_shipping_title',
    defaultMessage: 'Add your paid shipping option (optional)',
  },
  paidShippingDescription: {
    id: 'bo_seller-options-shipping-rule_drawer-paid_shipping_description',
    defaultMessage:
      'Boost your add-to-cart rates by offering 1 paid shipping method per market.',
  },
  freeMethodsNeeded: {
    id: 'bo_seller-options-shipping-rule_drawer-free_methods_needed',
    defaultMessage:
      'You must add free shipping options before you can add paid ones.',
  },
  next: {
    id: 'bo_seller-options-shipping-rule_drawer-next',
    defaultMessage: 'Next',
  },
  save: {
    id: 'bo_seller-options-shipping-rule_drawer-save',
    defaultMessage: 'Save',
  },
  toastAddRuleSuccessTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-toast_add_rule_success_title',
    defaultMessage: 'Shipping rules added ✔️',
  },
  toastAddRuleSuccessContent: {
    id: 'bo_seller-options-shipping-rule_drawer-toast_add_rule_success_description',
    defaultMessage: 'Nice work.',
  },
  toastAddRuleErrorTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-toast_add_rule_error_title',
    defaultMessage: 'Your shipping rules could not be saved',
  },
  toastAddRuleErrorContent: {
    id: 'bo_seller-options-shipping-rule_drawer-toast_add_rule_error_description',
    defaultMessage: 'Please try that again.',
  },
  collectionPointTitle: {
    id: 'bo_seller.options.shipping.rule_drawer.collection_point_title',
    defaultMessage: 'Collection point (optional)',
  },
  collectionPointDescription: {
    id: 'bo_seller.options.shipping.rule_drawer.collection_point_description',
    defaultMessage:
      'Set up this method for customers who choose to pick up orders from collection points. Available only to French sellers for domestic transactions.',
  },
} as const
